import { render, staticRenderFns } from "./todo-task.vue?vue&type=template&id=87ef5e62"
import script from "./todo-task.vue?vue&type=script&lang=js"
export * from "./todo-task.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports